var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogoIcon = function SvgLogoIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 900,
    viewBox: "0 0 900 900",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 242,
    y: 33,
    width: 416,
    height: 860
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450 878.112L246.447 36.5H653.553L450 878.112Z",
    fill: "#FBFAF8",
    stroke: "#04345C",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -4,
    width: 900,
    height: 900
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 446,
    r: 450,
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 450,
    r: 445,
    fill: "#F59E25",
    stroke: "#FBFAF8",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: -156.981,
    y: 622.428,
    width: 1279.08,
    height: 359.565,
    fill: "#FBFAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 103H625L450 827L275 103Z",
    fill: "#FBFAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.5 432C439 432 427.417 429.25 417.75 423.75C408.25 418.083 401.083 410.833 396.25 402C391.417 393.167 389 383.917 389 374.25V373H412.75V374.25C412.75 380.083 414.083 385.917 416.75 391.75C419.583 397.583 424 402.5 430 406.5C436 410.333 443.667 412.25 453 412.25C464 412.25 473.083 409.417 480.25 403.75C487.417 398.083 491 390.417 491 380.75C491 372.75 488.333 366.417 483 361.75C477.833 356.917 471.167 353.667 463 352L437.5 347.25C408.167 340.75 393.5 325.333 393.5 301C393.5 291 395.917 282.25 400.75 274.75C405.583 267.25 412.25 261.5 420.75 257.5C429.417 253.333 439.417 251.25 450.75 251.25C463.583 251.25 474.583 253.833 483.75 259C492.917 264.167 499.833 270.917 504.5 279.25C509.167 287.417 511.5 295.917 511.5 304.75V305.75H487.75V305C487.75 300 486.5 294.917 484 289.75C481.667 284.417 477.667 279.833 472 276C466.5 272.167 459.167 270.25 450 270.25C439.5 270.25 431.083 273.167 424.75 279C418.583 284.833 415.5 292.083 415.5 300.75C415.5 308.083 417.917 314.083 422.75 318.75C427.583 323.417 434.167 326.583 442.5 328.25L465.5 332.75C497.667 339.25 513.75 355 513.75 380C513.75 390.167 511.167 399.167 506 407C501 414.833 493.833 421 484.5 425.5C475.167 429.833 464.5 432 452.5 432Z",
    fill: "#04345C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M499.652 622.428L450.13 826.92L400.608 622.428H499.652Z",
    fill: "#04345C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 900,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/LogoIcon.0c7be22c.svg";
export { ForwardRef as ReactComponent };